export default class {

    constructor ($sce, TokenService) {
        this.$sce = $sce;
        this.TokenService = TokenService;
        this.baseUrl = `${SEED_CORE.ENV.WP_URL}`;
    }

    getCourseAddUrl () {
        return `${this.baseUrl}wp-admin/post-new.php?post_type=sfwd-courses`;
    }

    getCourseEditUrl (postId, lang) {
        return `${this.baseUrl}wp-admin/post.php?post=${postId}&action=edit&lang=${lang}`;
    }

    getCoursesUrl () {
        return `${this.baseUrl}wp-admin/edit.php?post_type=sfwd-courses`;
    }

    getLessonsUrl () {
        return `${this.baseUrl}wp-admin/edit.php?post_type=sfwd-lessons`;
    }

    getTopicsUrl () {
        return `${this.baseUrl}wp-admin/edit.php?post_type=sfwd-topic`;
    }

    getQuizzesUrl () {
        return `${this.baseUrl}wp-admin/edit.php?post_type=sfwd-quiz`;
    }

    getInteractiveElementsUrl () {
        return `${this.baseUrl}wp-admin/admin.php?page=h5p`;
    }

    /**
     * This function modifies urls and gets final url used in html
     * Token needs to come from outside to keep it from caching in Service
     * @param url string
     * @param token string
     * @returns {any}
     */
    getTokenizedUrl (url, token) {
        url = `${url}&lang=${this.TokenService.getCompanyLanguage(true)}&jwt=${token}`;
        return this.$sce.trustAsResourceUrl(url);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/material/index.js